







import { Component, Vue, Prop, Provide } from "vue-property-decorator";
import { closeDialog } from "./index";
import Fail from "./dialogTypes/Fail.vue";
import Open from "./dialogTypes/Open.vue";
import Success from "./dialogTypes/Success.vue";
@Component({
  components: {
    Fail,
    Open,
    Success
  }
})
export default class Dialog extends Vue {
  @Prop()
  /** 弹框类型 */
  dialogType!: string;

  @Prop()
  @Provide()
  /** 一些奇奇怪怪的东西 */
  someValue!: unknown;

  close(call: boolean) {
    closeDialog(call);
  }
}
